import bulb from "../assets/icons/bulb.png";
import growth from "../assets/icons/growth.png";
import enterprise from "../assets/icons/enterprice.png";

const experience = [
  {
    img: bulb,
    title: "Start-ups",
    description:
      "We follow a strategic approach to validate the hypothesis, accelerating time to market with hyper convergence of scope, delivering MVP in 3 months.",
  },
  {
    img: growth,
    title: "Mid-growth or transitioning",
    description:
      "We ensure technology and infrastructure alignment for high-growth SME organizations with evolving operational complexities so they can scale seamlessly​.",
  },
  {
    img: enterprise,
    title: "Enterprise",
    description:
      "We expertly handle some of the world's most complex organizations' processes with more than a billion dollars in sales transactions everyday​.",
  },
];

export default experience;
